import { action } from 'mobx';
import { globalStore, UserStore } from '../stores';

const { userStore } = globalStore;

export const userController = {
  set: action((update: Partial<UserStore>) => Object.assign(userStore, update)),
  get: userStore,
};
